import React, { FC } from 'react';
import { PlayIcon } from '../PlayIcon';
import styles from './PropertyCarousel.module.scss';
import classNames from 'classnames';

type PropertyCarouselSlideProps = {
	variant?: 'video' | 'iframe';
};

export const PropertyCarouselSlide: FC<PropertyCarouselSlideProps> = ({ variant, children }) => {
	return (
		<div
			className={classNames(styles.propertyCarouselSlide, {
				[styles[`propertyCarouselSlide--${variant}`]]: variant,
			})}
		>
			{children}

			{variant === 'video' && <PlayIcon size="lg" />}
		</div>
	);
};
